import { render, staticRenderFns } from "./Anatomy.vue?vue&type=template&id=166139a5&scoped=true&"
import script from "./Anatomy.vue?vue&type=script&lang=js&"
export * from "./Anatomy.vue?vue&type=script&lang=js&"
import style0 from "./Anatomy.vue?vue&type=style&index=0&id=166139a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166139a5",
  null
  
)

export default component.exports